<template>
  <v-card>
    <v-card-title>{{ $t('EMAILFORM.title') }}</v-card-title>
    <v-card-text class="pb-0">
      <v-form ref="emailform">
        <v-text-field
          v-if="to"
          v-model="to"
          :label="$t('EMAILFORM.email')"
          disabled
          :prepend-inner-icon="mdiEmail"
        ></v-text-field>
        <v-text-field
          v-model="subject"
          :label="$t('EMAILFORM.subject')"
          required
          :rules="[(v) => !!v || $t('EMAILFORM.subject_invalid')]"
          outlined
        ></v-text-field>
        <v-textarea
          v-model="title"
          :label="$t('EMAILFORM.title_field')"
          required
          :rules="[(v) => !!v || $t('EMAILFORM.title_invalid')]"
          outlined
          rows="2"
        ></v-textarea>
        <v-textarea
          v-model="template"
          :label="$t('EMAILFORM.template')"
          required
          :rules="[(v) => !!v || $t('EMAILFORM.template_invalid')]"
          outlined
          rows="5"
        ></v-textarea>
      </v-form>
    </v-card-text>
    <v-card-actions class="pt-0 pb-5 px-6">
      <v-btn
        text
        color="grey"
        @click="close()"
      >
        {{ $t('EMAILFORM.cancel') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        color="blue"
        :disabled="!isFormValid"
        :dark="isFormValid"
        @click="send()"
        :loading="loadingEmail"
      >
        {{ $t('EMAILFORM.confirm') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mdiEmail } from '@mdi/js';
  import { getInformParticipantsTemplate } from '../../helpers/emailTemplates/informParticipants'

  export default {
    name: "EmailForm",
    props: {
      toMany: {
        type: Boolean,
        default: false,
        required: false
      },
      to: {
        type: String,
        default: null,
        required: false
      },
      receivers: {
        type: Array,
        default: null,
        required: false
      },
      event: {
        type: Object,
        default: null,
        required: false
      }
    },
    data() {
      return {
        mdiEmail,
        subject: '',
        title: '',
        template: '',
        loadingEmail: false
      }
    },
    computed: {
      user() {
        return this.$store.state.auth.user;
      },
      isFormValid() {
        return !!this.subject && !!this.template;
      }
    },
    methods: {
      close() {
        this.subject = '',
        this.template = '',
        this.$emit('close');
      },
      async send() {
        this.loadingEmail = true;

        const payload = {
          from: process.env.VUE_APP_FIREBASE_EMAIL,
          subject: this.subject,
          template: getInformParticipantsTemplate({
            conferenceTitle: this.$t("HOME.title"),
            conferenceDate: this.$t("HOME.date"),
            event: this.event ? this.event.content[this.$i18n.locale].title : '',
            contentTitle: this.title,
            contentData: this.template,
            register: this.$t("MAILER.informParticipants.register"),
          })
        }

        if (this.toMany) {
          /**
           * @type {Boolean} - Whether the e-mails was successfully sent or not.
           */
          const haveSent = await this.$store.dispatch('sendEmailToMany', {
            ...payload,
            receivers: this.receivers.map(r => r.email)
          });

          this.$store.dispatch('setSnackbar', {
            show: true,
            text: this.$t(haveSent ? 'EMAILFORM.send_success_multiple' : 'EMAILFORM.send_fail_multiple'),
            color: haveSent ? 'success' : 'error',
          });
        } else {
          /**
           * @type {Boolean} - Whether the e-mail was successfully sent or not.
           */
          const haveSent = await this.$store.dispatch('sendEmail', {
            ...payload,
            to: this.to
          });
    
          this.$store.dispatch('setSnackbar', {
            show: true,
            text: this.$t(haveSent ? 'EMAILFORM.send_success' : 'EMAILFORM.send_fail', { email: this.to }),
            color: haveSent ? 'success' : 'error',
          });
        }
        
        this.loadingEmail = false;
        this.close();
      }
    }
  }
</script>
